import * as React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"

const Images = () => (
  <Layout>
    <SEO title="Images" />
    <Image />
  </Layout>
)

export default Images
